import { IStorageAdapter } from "../IStorageAdapter";

export class StorageService {
  private adapter: IStorageAdapter;

  constructor(adapter: IStorageAdapter) {
    this.adapter = adapter;
  }

  public async getItem<T>(key: string): Promise<T | null> {
    return await this.adapter.getItem<T>(key);
  }

  public getItemSync<T>(key: string): T | null {
    return this.adapter.getItemSync<T>(key);
  }

  public async setItem<T>(key: string, value: T): Promise<void> {
    await this.adapter.setItem<T>(key, value);
  }

  public setItemSync<T>(key: string, value: T): void {
    this.adapter.setItemSync<T>(key, value);
  }

  public async removeItem(key: string): Promise<void> {
    await this.adapter.removeItem(key);
  }

  public removeItemSync(key: string): void {
    this.adapter.removeItemSync(key);
  }

  public removeItemsByPrefixSync(prefixes: readonly string[]): void {
    this.adapter.removeItemsByPrefixSync(prefixes);
  }

  public async clear(): Promise<void> {
    await this.adapter.clear();
  }
}
